import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Log } from '../../../../../../interface/permanentdelegation/logs';
import { DataService } from '../../../../../../shared/data.service';
import { PermanentdelegationService } from '../../../../../../services/PermanentDelegation/permanentdelegation.service';
import { EmployeeDoaRequest, UsersDoa } from '../../../../../../interface/permanentdelegation/userdoa';
import { Router } from '@angular/router';
import { Permanentdelegation } from '../../../../../../interface/permanentdelegation/permanentdelegation';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { AppComponent } from '../../../../../../app.component';

@Component({
  selector: 'app-reviewscreen',
  imports: [MatTableModule, MatPaginatorModule, CommonModule, MatProgressBarModule],
  templateUrl: './reviewscreen.component.html',
  styleUrls: ['./reviewscreen.component.css']
})
export class ReviewscreenComponent implements OnInit {
  usersDoaArray: UsersDoa[] = [];
  logs: any[] = [];
  selectedCategory: string = '';
  selecteddirectreport: string = '';
  filteredData: Log[] = [];
  selectedRowData: any[] = [];
  cai: string = '';
  supervisorEmailAddress: string = '';
  loggeduser: string = '';
  data1: Permanentdelegation[] = [];
  loggedUserEmail: string = '';
  loggedUserCai: string = '';
  dataSource = new MatTableDataSource<Log>(this.filteredData);
  displayedColumns: string[] = ['actions', 'category', 'typeName', 'preferredname', 'manager', 'previousAmount', 'newAmount', 'percentage'];

  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }

  constructor(private dataService: DataService,
    private permanentDelegationService: PermanentdelegationService,
    private router: Router,
    private appComponent: AppComponent
  ) { }

  ngOnInit(): void {
    this.data1 = history.state.data1;
    if (this.data1) {
      this.cai = this.data1[0].cai;
      this.loggeduser = this.data1[0].preferredName;
      this.supervisorEmailAddress = this.data1[0].emailAddress;
      this.loggedUserEmail = this.appComponent.loggedUserEmail;
      this.loggedUserCai = '';

    }
    const data = this.dataService.getData();
    if (data) {
      this.selectedCategory = data.selectedCategory;
      this.selecteddirectreport = data.selecteddirectreport;
      this.filteredData = data.filteredData;
      this.logs = this.filteredData;
      this.selectedRowData = data.filteredData;
      this.dataSource.paginator = this.matPaginator;
    }
    this.processLogs();
    this.dataSource.data = this.logs;
    this.dataSource.paginator = this.matPaginator;
  }

  parsePercentage(value: string): number {
    return parseFloat(value);
  }

  getPercentageClass(value: string): string {
    const percentage = parseFloat(value);
    return percentage >= 75 ? 'high-percentage' : 'normal-percentage';
  }



  filteredLogs(): Log[] {
    return this.logs;
  }

  processLogs(): void {
    const currentDate = new Date()
const formattedDate = currentDate.toISOString().split('T')[0]; 
    this.logs = this.selectedRowData.map(item => {
      const key = item.preferredName || this.selecteddirectreport;
       return {
        typeName: item.typeName,
        typeCode: item.typeCode,
        catCode: item.catCode,
        catName: item.catName,
        preferredname: key,
        enteredDate: item.EnteredDate[key],
        lastEditDate: formattedDate,
        EnteredByCai: item.EnteredByCai[key],
        lastEditedBy: this.loggedUserEmail,
        subCatCode: item.subCatCode,
        manager: item.amounts[this.loggeduser] || 'N/A',
        previousAmount: item.amounts[key] || '0',
        newAmount: item.selectedAmount,
        Emailaddress: item.Emailaddress[key],
        percentage: this.calculatePercentage(item.amounts[this.loggeduser], item.selectedAmount),
        Emp_No: item.Emp_No[key]

      };
    });
    this.dataSource.data = this.logs;
    this.dataSource.paginator = this.matPaginator;
  }


  calculatePercentage(manager: string, newAmount: string): string {
    const prev = parseFloat(manager.replace(/,/g, ''));
    const newAmt = parseFloat(newAmount.replace(/,/g, ''));
    if (isNaN(prev) || isNaN(newAmt)) return 'N/A';
    return ((newAmt / prev) * 100).toFixed(2) + '%';
  }

  mapLogsToUsersDoa(): void {
    this.usersDoaArray = this.logs.map(log => ({
      cai: this.cai,
      emp_No: log.Emp_No,
      catCode: log.catCode,
      typeCode: log.typeCode,
      subCatCode: log.subCatCode,
      amount: log.newAmount.replace(/,/g, ''),
      enteredDate: log.enteredDate,
      lastEditDate: log.lastEditDate,
      lastEditedBy: this.loggedUserEmail,
      enteredByCai: this.loggedUserCai,
      typeName: log.typeName,
      catName: this.selectedCategory,
      fullName: log.preferredname,
      previousAmount: log.previousAmount,
      cc: this.supervisorEmailAddress,
      to: log.Emailaddress,
      managername: this.loggeduser,
      managerAmount: log.manager,
      loggedbycai: this.loggedUserEmail,
      percentage: log.percentage,
    }));
  }

  CreateDOA(): void {
    const highPercentageLogs = this.logs.filter(log => parseFloat(log.percentage) > 75);
    if (highPercentageLogs.length > 0) {
      alert('One or more entries have a percentage increase above 75%. Please review.');
      return;
    }
    this.mapLogsToUsersDoa();
    this.permanentDelegationService.createDOA(this.usersDoaArray).subscribe(
      (response) => {
        this.insertLogEntries()
        this.router.navigate(['PermanentDelegation/home/delegation/singledelegation/reviewscreen/submitscreen'], { state: { data: response } });
      },
      (error) => {
        alert('Failed to submit changes. Please try again.');
      }
    );
  }
  insertLogEntries(): void {
    const request: EmployeeDoaRequest = {
      employeesDoa: this.usersDoaArray
    };
    this.permanentDelegationService.submitEmployeeDoa(request).subscribe(
      response => {
        console.log('Log entries inserted successfully:', response);
        this.router.navigate(['PermanentDelegation/home/delegation/singledelegation/reviewscreen/submitscreen'], { state: { data: response } });
      },
      error => {
        console.error('Error inserting log entries:', error);

      }
    );
  }

  deleteRow(element: Log): void {
    const index = this.logs.indexOf(element);
    if (index >= 0) {
      this.logs.splice(index, 1);
      this.dataSource.data = [...this.logs];
    }
  }

  onClick(): void {
    if (this.selecteddirectreport) {
      this.router.navigate(['PermanentDelegation/home/delegation/singledelegation'], { state: { data: this.data1 } });
    } else {
      this.router.navigate(['PermanentDelegation/home/delegation/multipledelegation'], { state: { data: this.data1 } });
    }
  }
}
